// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3449) return "static/chunks/3449.9508c0b836465eab.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"2260":"163cf27b6ecaa990","2621":"a2079d9164482f9d","3542":"355b001617b1d299","4206":"494d8a1edfc967f7","4550":"84d722b5e2f9387e","5740":"dfe2d35b5df3bd92","7761":"8a27216f2dd8a2a7","7763":"082d82b75b30f98b","7808":"4ba88dec306fff11","9061":"a3a73ec3e4e55d61","9483":"1cc91030e08176c5"}[chunkId] + ".js";
};